export default __webpack_public_path__ + "dist/media/Create.d5301726.svg";